module.exports = __webpack_public_path__ + "static/media/indicator-b.1aace6a8.jpeg";